import { lazy } from 'react';

const AssociationHome = lazy(() =>
  import('../PAGES/USERASSOCIATION/ASSOCIATION/HOME/AssociationHome'),
);
const AssociationLevelup = lazy(() =>
  import('../PAGES/USERASSOCIATION/ASSOCIATION/LEVELUP/AssociationLevelup'),
);
const AssociationDojangList = lazy(() => import('../PAGES/USERASSOCIATION/Dojang/List/DojangList'));

// routes
const associationRoutes = {
  dashboard: [
    // dashboard
    { path: '/association/home', element: <AssociationHome /> },
    { path: '/association/levelup', element: <AssociationLevelup /> },
    { path: '/association/dojang/list', element: <AssociationDojangList /> },
  ],
};

export default associationRoutes;
